module.exports = __webpack_public_path__ + "img/Hungary.bbddd29d.svg";